import React from "react";

import { ResourceDisclosureHeader, ResourceDisclosurePanel } from './ResourceDisclosure';

// Global state for expanded resources to persist across re-renders
const expandedResources = new Map();

/**
 * @param {{resource: any, stableKey?: string}} props
 */
export const ListResource = ({ resource, stableKey }) => {
    const resourceKey = stableKey || resource?.reference || resource?._id;
    const [expanded, setExpanded] = React.useState(() => {
        return expandedResources.get(resourceKey) || false;
    });

    return <div className="box-border w-full">
        <ResourceDisclosureHeader
            expanded={expanded}
            onToggle={(e) => {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                const newExpanded = !expanded;
                setExpanded(newExpanded);
                expandedResources.set(resourceKey, newExpanded);
            }}
            testId="chat-resource-list-toggle"
            title={resource.title}
        />
        <ResourceDisclosurePanel expanded={expanded}>
            <ul className="mt-4 list-disc pl-6">{
                resource.data.map((item, idx) => {
                    // A list item may be a reference object ({_id, _type, label}) — React cannot
                    // render an object, so show its label (or name), never the raw shape.
                    const text = item && typeof item === 'object'
                        ? (item.label ?? item.name ?? item.title ?? JSON.stringify(item))
                        : item;
                    return <li key={idx}>{text}</li>
                })
            }</ul>
        </ResourceDisclosurePanel>
    </div>
}
